import React, { useEffect, useState } from "react";
import { TextField , styled }from '@mui/material'
import axios from "axios"
import { Link, useNavigate } from "react-router-dom";
import { GoogleLogin , GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import {motion} from 'framer-motion'
import backend_url from "../../config";

const EmailStyling=styled(TextField)(({ theme }) => ({
  width: '15rem',
  background: 'transparent',
  [theme.breakpoints.up('sm')]: {
  },
}))

const pageVariants = {
    initial: {
      rotateY: 90,
      opacity: 0,
    },
    in: {
      rotateY: 0,
      opacity: 1,
      transition: {
        duration: 1,
      },
    },
    out: {
      rotateY: -90,
      opacity: 0,
      transition: {
        duration: 1,
      },
    },
  };
  

const SignIn=()=>{
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const[username,setUsername]=useState();
    const[email,setEmail]=useState();
    const[password,setPassword]=useState();
    const[phoneNumber,setPhoneNumber]=useState();
    const navigate=useNavigate()
    let name="";
    let login=false;

    const submit = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            alert("Enter all the details!");
            return;
        }

        try {
            const res = await axios.post(`${backend_url}/signin`, {
            email,
            password,
            });

            if (res.data === "notexist") {
            alert("User not found");
            return;
            }

            if (res.data === "pwdnotmatch") {
            alert("Wrong password");
            return;
            }

            if (res.data.message === "success") {
            alert("Login successful");

            localStorage.setItem("token", res.data.token);
            localStorage.setItem("loginState", true);

            navigate("/", { state: { id: res.data.user.username, login: true } });
            window.location.reload();
            }
        } catch (err) {
            alert("Something went wrong");
            console.log(err);
        }
    };
    
    console.log(localStorage.getItem('token'));

    const responseSuccessGoogle = async (credentialResponse) => {
        try {
            console.log("Google credential:", credentialResponse);

            const { credential } = credentialResponse; 
            const decoded = jwtDecode(credential);
            console.log("Decoded user:", decoded);

            const res = await fetch(`${backend_url}/api/authenticate`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${credential}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ token: credential }),
            });

            const data = await res.json();
            console.log("Server response:", data);

            if (data.success) {
                localStorage.setItem("token", data.token);
                localStorage.setItem("login", true);
                navigate("/", { state: { id: data.user.username, login: true } });
                window.location.reload();
            } else {
                console.error("Authentication failed:", data.message);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const responseFailureGoogle = () => {
        console.log("Google login failed");
    };

    return(
        <motion.div className="w-full md:h-screen h-auto py-8"
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        style={{ perspective: 2000 }}>
            <div className='grid md:grid-cols-2 md:w-7/12 w-auto md:h-auto md:ml-auto md:mr-auto md:shadow-xl rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600'>
                
                <div className=" flex flex-col text-start bg-white rounded-tl-xl rounded-bl-xl">
                <div className="my-16 space-y-4 items-center justify-center text-center">
                    <h1 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">Sign in to myjourney</h1>
                    <GoogleOAuthProvider clientId="297704508492-ci2ff1dipf6i9sliop0m02k2pqtcdalo.apps.googleusercontent.com">
                    <div className="cursor-pointer mx-[20%]">
                        <GoogleLogin
                            className="border-2 border-gray-200 rounded-full p-2 w-24 cursor-pointer mx-[40%]"
                            buttonText="Login"
                            onSuccess={responseSuccessGoogle}
                            onError={responseFailureGoogle}
                        />
                    </div>
                    </GoogleOAuthProvider>
                    <h1 className="text-md text-gray-500">or use your email account</h1>
                    <EmailStyling label="Email" variant="outlined" value={email} onChange={e=> setEmail(e.target.value)} required={true}/>
                    <EmailStyling  label="Password"  type="password" variant="outlined" value={password} onChange={e=> setPassword(e.target.value)} required={true}/>
                    <h1 className="mx-auto text-gray-600 cursor-pointer" onClick={()=> navigate('/reset-password')}>Forgot your password</h1>
                    <div className="uppercase p-2 font-semibold text-white text-xl cursor-pointer bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full px-8 w-36 mx-auto" onClick={submit}>Sign in</div>
                </div>
                </div>
                
                <div className="md:my-auto my-16 space-y-6">
                    <h1 className="font-bold capitalize text-white text-3xl">Hello, Friend!</h1>
                    <h1 className="text-white text-md ">Enter your personal details and start journey with us</h1>
                    <div className="bg-transparent border-2 rounded-full w-44 p-2 mx-auto text-xl text-white cursor-pointer uppercase"><Link to='/signup'>Sign up</Link></div>
                </div>

            </div>
        </motion.div>
    )
}

export default SignIn;